import React from 'react';
import { connect } from 'react-redux';

import '../../static/less/loyalty.less';

import PropTypes from 'prop-types';
import DsCoinBadge from '../ds/molecules/CoinBadge';
import { setShowLogin, setShowRegistration } from '../../actions/Loyalty';

class BecomeMemberInMyBooking extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showLogin: false,
      showRegistration: false,
    };
  }

  asLoyaltyMemberInfoInLoyaltyTab() {
    const { loyalty_main_url } = this.props.chainData.booking_engine_configuration;
    return (
      <div className={'flex-grow-2 text-base mr-2'}>
        <p className={'mb-2'}>{
          this.context.t('As a {chain} member you can get discounts and benefits in exchange of coins', {
            chain: this.props.chainData.loyalty_name.toUpperCase(),
          })}.
        </p>
        <DsCoinBadge
          className='p-2'
          coins={this.props.coins}
          lang={this.props.lang}
          loyalty={this.props.loyalty}
          loggedUser={this.props.loggedUser}
          showURL={false}
        >
          {this.context.t('When checking out of the hotel, {chain} coins will be added to the account of the {chain} Member who made the reservation. The amount will be based on the percentage corresponding to their membership level, calculated on the amount of the stay (without tax).', {
            chain: this.props.chainData.loyalty_name.toUpperCase(),
          })}
        </DsCoinBadge>
        <p>
          {this.context.t('Visit ')}
          <a className={'text-primary'} href={loyalty_main_url}>{loyalty_main_url}</a>
          {this.context.t(' to see all benefits')}.
        </p>
      </div>
    );
  }

  becomeMemberInLoyaltyTab() {
    return (
      <div className='px-1 text-justify'>
        <div>
          <button
            className={'blue-style w-100 justify-center'}
            onClick={() => {
              this.props.dispatch(setShowRegistration(true));
            }}
          >
            {this.context.t('Become a member')}
          </button>
          <button
            className={'white-style w-100'}
            onClick={() => {
              this.props.dispatch(setShowLogin(true));
            }}
          >
            {this.context.t('Login')}
          </button>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className={'notLoggedInMyBooking mb-2 d-flex justify-between flex-wrap md:flex-nowrap '}>
        {this.asLoyaltyMemberInfoInLoyaltyTab()}
        <div className={'becomeMemberInMyBooking w-calc-30 shadow-card border-primary border-2 p-2'}>
          <DsCoinBadge
                  coins={this.props.coinsForRegistering}
                  lang={this.props.lang}
                  loyalty={this.props.loyalty}
                  loggedUser={this.props.loggedUser}
                  className='p-2'
          >
            {this.context.t('Become a member now and get extra coins to use during your stay')}
          </DsCoinBadge>
          {this.becomeMemberInLoyaltyTab()}
        </div>
      </div>
    );
  }
}

BecomeMemberInMyBooking.propTypes = {
  loyalty: PropTypes.object.isRequired,
  coins: PropTypes.number.isRequired,
  lang: PropTypes.string.isRequired,
};

BecomeMemberInMyBooking.contextTypes = {
  t: PropTypes.func.isRequired,
};
export default connect(((state) => ({
  chainData: state.session.chainData,
  loggedUser: state.loyalty.loggedUser,
  hasRegistered: state.loyalty.hasRegistered,
  coinsForRegistering: state.loyalty.coinsForRegistering,
})))(BecomeMemberInMyBooking);
